import React, { Component } from 'react'
import * as copy from '../text_data/template.json'
import loadingGif from '../images/loader.gif'
import styles from '../styles/store-list.module.css'

export class StoreList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      status: 'INITIAL',
      numShownStores: 4
    }

    this.showMoreStores = this.showMoreStores.bind(this)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.loading !== this.props.loading && this.props.loading) {
      this.setState({
        status: 'LOADING'
      })
    }
    
    if (prevProps.searchResult !== this.props.searchResult) {
      if (this.props.searchResult.error) {
        this.setState({
          status: 'ERROR'
        })
      } else {
        this.setState({
          status: 'SUCCESS',
          numShownStores: 4
        })
      }
    }
  }

  handleMouseEnter (id) {
    if (window.matchMedia("(min-width: 1025px)").matches)
      this.props.highlightStores([id])
  }

  handleMouseLeave () {
    this.props.highlightStores([])
  }

  handleStoreClick (id) {
    if (window.matchMedia("(max-width: 1024px)").matches)
      this.props.highlightStores([id])
  }

  showMoreStores () {
    this.setState({
      numShownStores: this.state.numShownStores + 3
    })
  }

  renderStores () {
    const storeInfos = this.props.stores.sort((x, y) => {
      return x.distance.val - y.distance.val
    }).filter((store, index) => {
      if (window.matchMedia("(min-width: 1025px)").matches) {
        return true
      } else {
        return index < this.state.numShownStores
      }
    }).map((store) => {
      const startAddress = `${store.distance.from.lat.toString()},${store.distance.from.lng.toString()}`
      const destAddress = `${store.latitude.toString()},${store.longitude.toString()}`

      return (
        <div
          className={styles['store']}
          key={store.id}
          onMouseEnter={() => this.handleMouseEnter(store.id)}
          onMouseLeave={() => this.handleMouseLeave(store.id)}
          onClick={() => this.handleStoreClick(store.id)}>
          <div className={styles['store__info']}>
            <div className={styles['store__info__main']}>
              <button className={`${styles['store__marker']} ${this.props.highlightedStores.indexOf(store.id) !== -1 && styles['store__marker--highlighted']}`} onClick={() => this.props.selectStore(store.id)} onFocus={() => this.handleMouseEnter(store.id)} onBlur={() => this.handleMouseLeave(store.id)}>
                <svg x="0px" y="0px" viewBox="0 0 29.1 41.6">
                  <path d="M24.9,4.2C22,1.4,18.6,0,14.6,0c-4,0-7.5,1.4-10.3,4.2C1.4,7.1,0,10.5,0,14.6c0,2,0.5,4.4,1.6,7c1,2.7,2.2,5.1,3.5,7.2 c1.3,2.1,2.7,4.3,4.4,6.5c1.7,2.2,2.9,3.7,3.5,4.5c0.6,0.7,1.2,1.4,1.6,1.8l1.6-1.7c1-1.2,2.2-2.8,3.6-4.7c1.4-2,2.8-4.1,4.2-6.4 c1.4-2.3,2.7-4.7,3.7-7.3c1-2.6,1.5-4.9,1.5-6.9C29.1,10.5,27.7,7.1,24.9,4.2z"></path>
                </svg>
                <span className={styles['store__marker__distance']}>{store.distance.val}<br />km</span>
              </button>
              <div className={styles['store__details']}>
                <div className={styles['store__details__text--black']}>{store.name}</div>
                <div className={styles['store__details__text']}>{store.address}</div>
                <div className={styles['store__details__text']}>{store.city}, {store.province} {store.postal_code}</div>
                {store.phone && <a href={`tel:${store.phone.replace('-', '')}`} className={styles['store__details__text']}>{store.phone}</a>}
                {store.distance && <div className={styles['store__details__text']}>{copy.storeList.distance[this.props.lang]}: {store.distance.val} km</div>}
                {window.matchMedia('(max-width: 1024px)').matches &&
                  <div className={styles['store__details__text']}>
                    <a target="_blank" rel="noopener noreferrer" href={`https://www.google.com/maps?saddr=${encodeURIComponent(startAddress)}&daddr=${encodeURIComponent(destAddress)}`} className={`${styles['store__details__links__item']} ${styles['store__details__direction']} ${styles['store__details__links__item--font-brandon']}`}>
                      {copy.storeList.directions[this.props.lang]}
                    </a>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      )
    })

    if (this.props.stores.length > this.state.numShownStores && window.matchMedia("(max-width: 1024px)").matches) {
      storeInfos.push(
        <button key="button" className={styles['show-more-btn']} onClick={this.showMoreStores}>
          {copy.storeList.moreLocations[this.props.lang]}
        </button>
      )
    }

    return storeInfos
  }

  renderContents () {
    switch (this.state.status) {
      case `INITIAL`:
        return (
          <div className={styles['location-list-text-container']}>
            <p className={styles['no-input__text']}>{copy.storeList.findLocations[this.props.lang]}</p>
          </div>
        )
      case `ERROR`:
        return (
          <div className={styles['location-list-text-container']}>
            <h2 className={styles['not-found-error__heading']}>
              {this.props.searchResult.error === 'NOT_FOUND' ? copy.storeList.notFoundHeading[this.props.lang] : copy.storeList.currentLocNotFoundHeading[this.props.lang]}
            </h2>
            <p className={styles['not-found-error__text']}>
              {this.props.searchResult.error === 'NOT_FOUND' ? copy.storeList.notFoundText[this.props.lang] : copy.storeList.currentLocNotFoundText[this.props.lang]}
            </p>
          </div>
        )
      case `LOADING`:
        return (
          <div className={styles['loader-container']}>
            <img className={styles['loader']} src={loadingGif} alt={copy.storeList.loading[this.props.lang]} />
          </div>
        )
      default:
        return this.renderStores()
    }
  }

  render () {
    return (
      <div className={styles['location-list']}>
        { this.renderContents() }
      </div>
    )
  }
}

export default StoreList